import React from 'react';
import Icon from '../Icon';
import { STYLE_NAMESPACE } from './Types';
import BadgeContent from './BadgeContent';
var ICON_SIZE_MAP = new Map([
    ['xsmall', 'medium'],
    ['small', 'medium'],
    ['medium', 'large'],
    ['large', 'xxlarge'],
]);
var AiBadgeContent = function (_a) {
    var children = _a.children, iconName = _a.iconName, _b = _a.size, size = _b === void 0 ? 'medium' : _b, style = _a.style, className = _a.className;
    return children ? (React.createElement(BadgeContent, { iconName: iconName, size: size, style: style, className: className }, children)) : (React.createElement("div", { className: "".concat(className, " ").concat(STYLE_NAMESPACE, "_icon"), style: style },
        React.createElement("span", { className: "".concat(STYLE_NAMESPACE, "__inner-icon") },
            React.createElement(Icon, { name: iconName || 'ai-label', size: ICON_SIZE_MAP.get(size) }))));
};
export default React.memo(AiBadgeContent);
